import ZoomEventModel from "./ZoomEventModel";

export default class ZoomTimelineModel {
  constructor(data) {
    if (!data) {
      data = {};
    }

    this.events = (data.events || []).map(event => new ZoomEventModel(event));
  }
}
